import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, Observable } from 'rxjs';
import { ScriptingProperty, ScriptConfiguration } from './cpq-scripting.model';
import { UrlPrefix } from "../common/constants/url-prefix.constants";

@Injectable()
export class ScriptingService {
    public scriptChanged: BehaviorSubject<number> = new BehaviorSubject(0);
    scriptId = this.scriptChanged.asObservable();
    constructor(private http: HttpClient) {
    }

    public GetFirstLevelProperties(mode: string): Observable<Array<ScriptingProperty>> {
        return this.http.get<Array<ScriptingProperty>>(`${UrlPrefix.OLD_SETUP_API_PREFIX}/ironPythonContext/properties/firstLevel/${mode}`);
    }

    public GetProperties(fullName: string, assemblyName: string): Observable<ScriptingProperty> {
        return this.http.get<ScriptingProperty>(`${UrlPrefix.OLD_SETUP_API_PREFIX}/ironPythonContext/properties/${fullName}/${assemblyName}`);
    }

    public CheckSyntax(scriptingCodemirror: ScriptConfiguration): Observable<string> {
        return this.http.post<string>(`${UrlPrefix.OLD_SETUP_API_PREFIX}/ironPythonContext/syntax`, JSON.stringify(scriptingCodemirror));
    }

    public checkScriptContainsNewStyleClass(script: string): Observable<number> {
        return this.http.post<number>(`${UrlPrefix.OLD_SETUP_API_PREFIX}/ironPythonContext/syntax/newStyleClasses`, JSON.stringify(script));
    }

    public updatedScriptChange(scriptId: number){
        this.scriptChanged.next(scriptId);
    }
}
